import { useState, useEffect } from "react";
import { SwapPassDiv } from "./styled";
import api from "../../../../services/Api";
import { Button, InputText } from "../../../../ui/InputControls";
import { getJwtToken } from "../../../../contexts/authentication";
import { useAlert } from "../../../../contexts/alert";
import { TitleBig } from "../../../../ui/Texts";
import { useLightbox } from "../../../../contexts/lightbox";
import { useCiclos } from "../../../../contexts/ciclos";
import { usePreload } from "../../../../contexts/preloading";
import { storage } from "../../../../utils/StorageHelper";
import { useUser } from "../../../../contexts/user";

const LightboxChangePass = () => {
  const { setPreloading } = usePreload();
  const { user } = useUser();
  const { setLightbox } = useLightbox();
  const { setClasseAlert, setAlertText, setAlertType } = useAlert();
  const [usuario, setUsuario] = useState(null);
  const [senha, setSenha] = useState(null);
  const [confirmSenha, setConfirmSenha] = useState(null);
  const [userNameStorage, setUserNameStorage] = useState(null)

  const [path, setPath] = useState(null)

  useEffect(() => {
      let userValues = JSON.parse(storage.getTokenUser());
      let userId = userValues.data[11].value;
      setUserNameStorage(userId);
      //console.log("UserDataStorage: ", userId)

      if (user.currentRole === "Administrador") {
        setPath("ResetPassword")
      }else{
        setPath("ChangePassword")
      }
    }, [user]);
  
  const confirmaAlterarSenha = async (e) => {
    setPreloading(true);

    if (senha !== confirmSenha){
      setAlertText("Senhas não coincidem, Tente novamente.");
      setAlertType("error");
      setClasseAlert("on");
      setPreloading(false);
      return;
    }


    let path = user?.currentRole === "Administrador" ? "ResetPassword" : "ChangePassword";
    //console.log("Role teste aqui:", user.currentRole)
    //console.log("path para teste: ", path)

    e.preventDefault();
    e.stopPropagation();

    const content = {
      userName: user?.currentRole === "Administrador" ? usuario : userNameStorage,
      password: senha,
    };

    const config = {
      headers: { Authorization: `Bearer ${storage.getToken()}` },
    };

    api
      .post(`/Account/${path}`, content, config)
      .then(async (res) => {
        if (res.status === 200) {
          //console.log(res.data);
          setAlertText("Senha alterada com sucesso!");
          setAlertType("success");
          setClasseAlert("on");
          setLightbox("");
          setPreloading(false);
        }
      })
      .catch((error) => {
        //console.log(error);
        setAlertText("Erro ao alterar senha.");
        setAlertType("error");
        setClasseAlert("on");
        setPreloading(false);
      });
  };

  return (
    <SwapPassDiv>
      <TitleBig margin="20px">Alterar senha de usuário</TitleBig>
      
      {
        user?.currentRole === "Administrador" ? 
          <InputText
            width="80%"
            id="usuario"
            placeholder="Login do usuário..."
            value={usuario}
            onChange={setUsuario}
          />
        
        : 
      
        ""

      }
      
      
      <InputText
        width="80%"
        id="senha"
        placeholder="Nova senha..."
        value={senha}
        onChange={setSenha}
      />

      <InputText
        width="80%"
        id="senha"
        placeholder="Confirme a senha..."
        value={confirmSenha}
        onChange={setConfirmSenha}
      />

      <Button
        width="150px"
        title="Alterar"
        color="primary"
        margin="20px"
        onClick={confirmaAlterarSenha}
      />
    </SwapPassDiv>
  );
};

export default LightboxChangePass;
